<template>
    <div class="login-box">

        <div class="card">
            <div class="card-body login-card-body text-center">
                
                <h3 v-if="!$route.query.ticket">Recuperando informações de acesso</h3>
                <h3 v-else-if="error">Aconteceu um erro inesperado!</h3>
                <h3 v-else-if="not_allowed">Acesso não autorizado</h3>
                <h3 v-else>Realizando autorização</h3>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/api'

export default {
    name: 'Login',
    data() {
        return {
            username: null,
            password: null,
            error: false,
            not_allowed: false,
        }
    },
    methods: {
        async login() {
            if ('ticket' in this.$route.query) {
                const response = await api.get('login', {
                    ticket: this.$route.query.ticket
                })
                if (response.ok) {
                    let token = response.headers.authorization
                    let claims = JSON.parse(Buffer.from(token.split('.')[1], 'base64').toString())

                    if (claims.roles.length == 0) {
                        this.not_allowed = true
                        return;
                    }

                    localStorage.setItem('token', token)
                    localStorage.setItem('roles', claims.roles)
                    this.$router.push('/')
                } else {
                    this.error = true
                }
            } else{
                window.location = `${process.env.VUE_APP_BACKEND}/login`
            }
        }
    },
    mounted() {
        document.body.classList.add('login-page')
        this.login()
    },
    destroyed() {
        document.body.classList.remove('login-page')
    }
}
</script>